/* Chan's native cart drawer (replaces Monster Cart Upsell). No dependencies. */
(function () {
  'use strict';
  if (window.ChansCart) return;

  var MARK = 'X-Chans-Cart';                      // header that tags our own requests
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?\/?(?:$|[?#])/;
  var ADD_RE = /\/cart\/add(\.js)?\/?(?:$|[?#])/;
  var root, drawer, inner, lastFocus = null, refreshTimer = null, busy = 0;

  function cfg(name, fallback) { return (root && root.getAttribute(name)) || fallback; }
  function cartUrl() { return cfg('data-cart-url', '/cart'); }
  function rootUrl() { var r = cfg('data-root-url', '/'); return r.charAt(r.length - 1) === '/' ? r : r + '/'; }
  function onCartPage() {
    if (window.theme && window.theme.template === 'cart') return true;
    return location.pathname.replace(/\/$/, '') === cartUrl().replace(/\/$/, '');
  }
  function emit(name, detail, target) {
    (target || document).dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }
  function headers(json) {
    var h = { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    h[MARK] = '1';
    if (json) h['Content-Type'] = 'application/json';
    return h;
  }
  // Always call window.fetch at call time with a STRING url, so that Stoq's fetch hijack
  // (which only inspects string urls + init.body) can add its selling_plan / properties.
  function req(url, init) {
    return window.fetch(url, init).then(function (r) {
      return r.text().then(function (t) {
        var data = null; try { data = t ? JSON.parse(t) : null; } catch (e) { data = t; }
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'Sorry, something went wrong. Please try again.';
          var err = new Error(msg); err.status = r.status; err.data = data; throw err;
        }
        return data;
      });
    });
  }

  /* ---------- render ---------- */
  function setCount(n) {
    document.querySelectorAll('.header__cart-count, [data-cart-count]').forEach(function (el) { el.textContent = n; });
    if (window.theme) window.theme.cartCount = n;
  }
  function showMsg(text) {
    var m = inner && inner.querySelector('[data-cc-msg]');
    if (!m) return;
    if (text) { m.textContent = text; m.hidden = false; } else { m.textContent = ''; m.hidden = true; }
  }
  function refresh(opts) {
    opts = opts || {};
    var url = cartUrl() + '?view=chans-drawer&t=' + Date.now();
    var hh = { 'Accept': 'text/html' }; hh[MARK] = '1';
    return window.fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: hh })
      .then(function (r) { if (!r.ok) throw new Error('render ' + r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-cc-content]');
        if (!fresh || !inner) return;
        var oldBody = inner.querySelector('[data-cc-body]');
        var scroll = oldBody ? oldBody.scrollTop : 0;
        var act = document.activeElement, refocus = null;
        if (act && drawer.contains(act)) {
          ['data-cc-qty', 'data-cc-input', 'data-cc-remove'].some(function (a) {
            if (act.hasAttribute(a)) { refocus = '[' + a + '="' + act.getAttribute(a) + '"]' + (act.hasAttribute('data-cc-step') ? '[data-cc-step="' + act.getAttribute('data-cc-step') + '"]' : ''); return true; }
          });
          if (!refocus) refocus = '.cc-x';
        }
        inner.innerHTML = '';
        inner.appendChild(fresh);
        var newBody = inner.querySelector('[data-cc-body]');
        if (newBody && opts.keepScroll !== false) newBody.scrollTop = scroll;
        if (refocus) {
          var f = null; try { f = drawer.querySelector(refocus); } catch (e) {}
          f = f || drawer.querySelector('.cc-x');
          if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
        }
        setCount(fresh.getAttribute('data-cc-count') || '0');
        if (opts.message) showMsg(opts.message);
        applyRating();
        emit('cart:rerendered', { source: 'chans-cart' });
      });
  }
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refresh().catch(function () {}); }, 350);
  }
  function setBusy(on) {
    busy += on ? 1 : -1; if (busy < 0) busy = 0;
    if (root) root.classList.toggle('is-busy', busy > 0);
  }


  /* ---------- live Yotpo rating (all reviews), cached 6h ---------- */
  var YOTPO_KEY = 'TUZAChaoduhFZFdVbAemoKChwkmfpth2VIB95PBQ', RKEY = 'chansCartRating', rating = null, ratingLoading = false;
  function applyRating() {
    if (!rating || !drawer) return;
    var s = drawer.querySelector('[data-cc-rs]'), c = drawer.querySelector('[data-cc-rc]');
    if (s) s.textContent = rating.avg.toFixed(2).replace(/0$/, '') + '/5';
    if (c) c.textContent = rating.total.toLocaleString('en-US') + ' customer reviews';
  }
  function loadRating() {
    try { var x = JSON.parse(sessionStorage.getItem(RKEY) || 'null'); if (x && Date.now() - x.t < 216e5) { rating = x; applyRating(); return; } } catch (e) {}
    if (ratingLoading) return; ratingLoading = true;
    window.fetch('https://api-cdn.yotpo.com/v1/widget/' + YOTPO_KEY + '/reviews.json?per_page=1&page=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var b = d && d.response && d.response.bottomline;
        if (!b || !b.total_review || !b.average_score) return;
        rating = { avg: Math.round(b.average_score * 100) / 100, total: b.total_review, t: Date.now() };
        try { sessionStorage.setItem(RKEY, JSON.stringify(rating)); } catch (e) {}
        applyRating();
      }).catch(function () {}).then(function () { ratingLoading = false; });
  }

  /* ---------- open / close ---------- */
  function focusables() {
    return Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function open() {
    if (!root) return;
    if (!root.hidden && root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('cc-lock');
    // next frame so the transition runs
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      root.classList.add('is-open');
      var x = drawer.querySelector('[data-cc-close].cc-x') || drawer;
      try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); }
    }); });
    loadRating();
    emit('chans-cart:open');
  }
  function close() {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('cc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) root.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    emit('chans-cart:close');
  }
  function isOpen() { return root && !root.hidden && root.classList.contains('is-open'); }

  /* ---------- cart actions ---------- */
  function changeLine(key, qty) {
    showMsg('');
    setBusy(true);
    return req(rootUrl() + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: headers(true), body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { return refresh(); })
      .catch(function (err) { return refresh({ message: err.message }).catch(function () { showMsg(err.message); }); })
      .then(function () { setBusy(false); });
  }

  function formError(form, text) {
    var box = form.querySelector('.cc-form-error');
    if (!text) { if (box) box.remove(); return; }
    if (!box) {
      box = document.createElement('p');
      box.className = 'cc-form-error';
      box.setAttribute('role', 'alert');
      var anchor = form.querySelector('.product-form__payment-container') || form.querySelector('[type="submit"]');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling); else form.appendChild(box);
    }
    box.textContent = text;
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || e.defaultPrevented) return;
    if (form.hasAttribute('data-cc-ignore') || form.closest('#chans-cart-drawer')) return;
    var submitter = e.submitter || null;
    var action = (submitter && submitter.getAttribute('formaction')) || form.getAttribute('action') || '';
    if (!ADD_RE.test(action)) return;
    e.preventDefault();               // native POST is cancelled -> Stoq's (optional) ajax submit sees defaultPrevented and stands down

    var fd;
    try { fd = submitter ? new FormData(form, submitter) : new FormData(form); } catch (err) { fd = new FormData(form); }
    var btn = submitter || form.querySelector('[type="submit"]');
    if (btn) { if (btn.disabled && btn.getAttribute('aria-busy') === 'true') return; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    formError(form, '');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
    req(rootUrl() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: headers(false), body: fd })
      .then(function (item) {
        emit('product:added', { variant: null, quantity: qty, item: item, source: 'chans-cart' }, form);
        // Item is in the cart. If the drawer can't render for any reason, fall back to the cart page.
        return refresh({ keepScroll: false }).then(open, function () { location.href = cartUrl(); });
      })
      .catch(function (err) {
        formError(form, err.message);
        if (window.console) console.warn('[ChansCart] add failed:', err.message);
      })
      .then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
  }

  function onUpsellAdd(btn) {
    var card = btn.closest('[data-cc-card]');
    var sel = card && card.querySelector('[data-cc-variant]');
    var id = sel && parseInt(sel.value, 10);
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    showMsg('');
    req(rootUrl() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: headers(true), body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (data) {
        btn.classList.add('is-added'); btn.removeAttribute('aria-busy'); btn.textContent = 'Added';
        emit('product:added', { variant: null, quantity: 1, item: data, source: 'chans-cart-upsell' });
        return refresh();
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy'); btn.disabled = false;
        showMsg(err.message);
      });
  }

  /* ---------- event wiring ---------- */
  function onDrawerClick(e) {
    var t = e.target;
    var closeEl = t.closest('[data-cc-close]');
    if (closeEl) {
      if (closeEl.tagName === 'A' && closeEl.classList.contains('cc-cont')) e.preventDefault();
      close(); return;
    }
    var rm = t.closest('[data-cc-remove]');
    if (rm) { changeLine(rm.getAttribute('data-cc-remove'), 0); return; }
    var step = t.closest('[data-cc-qty]');
    if (step) {
      var key = step.getAttribute('data-cc-qty');
      var input = drawer.querySelector('[data-cc-input="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
      var cur = input ? parseInt(input.value, 10) || 0 : 0;
      var next = Math.max(0, cur + parseInt(step.getAttribute('data-cc-step'), 10));
      if (input) input.value = next;
      changeLine(key, next); return;
    }
    var add = t.closest('[data-cc-upsell-add]');
    if (add) { onUpsellAdd(add); return; }
  }
  function onDrawerChange(e) {
    var t = e.target;
    if (t.matches('[data-cc-input]')) {
      var v = parseInt(t.value, 10);
      if (isNaN(v) || v < 0) v = 0;
      changeLine(t.getAttribute('data-cc-input'), v);
    } else if (t.matches('select[data-cc-variant]')) {
      var opt = t.options[t.selectedIndex];
      var p = t.closest('[data-cc-card]').querySelector('[data-cc-price]');
      if (opt && p) {
        p.textContent = opt.getAttribute('data-price') || '';
        var c = opt.getAttribute('data-compare');
        if (c) { var s = document.createElement('s'); s.textContent = c; p.appendChild(s); }
      }
    }
  }
  function onKey(e) {
    if (!isOpen()) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { e.preventDefault(); drawer.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function onDocClick(e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || a.closest('#chans-cart-drawer')) return;
    var inHeader = a.classList.contains('header__cart-toggle') || a.closest('#shopify-section-header, .header, [data-section-type="header"]');
    if (!inHeader) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== cartUrl().replace(/\/$/, '')) return;
    if (onCartPage()) return;
    e.preventDefault();
    e.stopPropagation();
    open();
    refresh().catch(function () {});
  }

  /* ---------- detect cart changes made by other scripts (Stoq, theme, apps) ---------- */
  function isOurs(init) {
    var h = init && init.headers;
    if (!h) return false;
    if (typeof h.get === 'function') return !!h.get(MARK);
    return !!h[MARK];
  }
  function patchFetch() {
    if (!window.fetch || window.fetch.__chansCart) return;
    var prev = window.fetch;
    var wrapped = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = prev.apply(this, arguments);
      if (CART_RE.test(url) && !isOurs(init)) {
        p.then(function (r) { if (r && r.ok) scheduleRefresh(); }, function () {});
      }
      return p;
    };
    wrapped.__chansCart = true;
    window.fetch = wrapped;
  }
  function patchXHR() {
    var X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!X || X.__chansCart) return;
    var o = X.open, s = X.send;
    X.open = function (m, url) { this.__ccUrl = String(url || ''); return o.apply(this, arguments); };
    X.send = function () {
      var x = this;
      if (CART_RE.test(x.__ccUrl || '')) x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) scheduleRefresh(); });
      return s.apply(this, arguments);
    };
    X.__chansCart = true;
  }

  /* ---------- init ---------- */
  function setup() {
    var found = document.querySelectorAll('#chans-cart-drawer');
    if (!found.length) return false;
    var el = found[found.length - 1];              // newest (theme editor re-render)
    for (var i = 0; i < found.length - 1; i++) found[i].remove();
    if (el.parentNode !== document.body) document.body.appendChild(el);   // escape header stacking context
    if (el === root) return true;
    root = el;
    drawer = root.querySelector('.cc-drawer');
    inner = root.querySelector('[data-cc-inner]');
    drawer.addEventListener('click', onDrawerClick);
    drawer.addEventListener('change', onDrawerChange);
    root.querySelector('.cc-overlay').addEventListener('click', close);
    return true;
  }
  function init() {
    if (!setup()) return;
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onKey);
    document.addEventListener('chans-cart:refresh', function () { refresh().catch(function () {}); });
    document.addEventListener('cart:refresh', scheduleRefresh);
    document.addEventListener('shopify:section:load', function () { setup(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().catch(function () {}); });
    patchFetch();
    patchXHR();
    setCount(inner.querySelector('[data-cc-content]') ? inner.querySelector('[data-cc-content]').getAttribute('data-cc-count') : (window.theme && window.theme.cartCount) || 0);
  }

  window.ChansCart = { open: open, close: close, refresh: refresh, isOpen: isOpen };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
